module.exports = __webpack_public_path__ + "img/icon2.e4cc0561.png";